// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_cmp_editor = require("./MM_cmp_editor.bs.js");
var MM_cmp_pe_index = require("../explorer/MM_cmp_pe_index.bs.js");
var MM_cmp_settings = require("./MM_cmp_settings.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_UseTabs = require("../../rescript-utils/main/react-components/Expln_React_UseTabs.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var MM_wrk_pre_ctx_data = require("../worker/MM_wrk_pre_ctx_data.bs.js");
var Styles = require("@mui/material/styles");
var MM_cmp_pe_frame_full = require("../explorer/MM_cmp_pe_frame_full.bs.js");
var MM_cmp_context_selector = require("./MM_cmp_context_selector.bs.js");
var Expln_React_ContentWithStickyHeader = require("../../rescript-utils/main/react-components/Expln_React_ContentWithStickyHeader.bs.js");

function createInitialState(settings) {
  return {
          preCtxData: MM_wrk_pre_ctx_data.preCtxDataMake(settings),
          ctxSelectorIsExpanded: true
        };
}

function updatePreCtxData(st, settings, ctx, param) {
  return {
          preCtxData: MM_wrk_pre_ctx_data.preCtxDataUpdate(st.preCtxData, settings, ctx, undefined),
          ctxSelectorIsExpanded: st.ctxSelectorIsExpanded
        };
}

function updateCtxSelectorIsExpanded(st, ctxSelectorIsExpanded) {
  return {
          preCtxData: st.preCtxData,
          ctxSelectorIsExpanded: ctxSelectorIsExpanded
        };
}

var mainTheme = Styles.createTheme({
      palette: {
        white: {
          main: "#ffffff"
        },
        grey: {
          main: "#e0e0e0"
        },
        red: {
          main: "#FF0000"
        },
        pastelred: {
          main: "#FAA0A0"
        },
        orange: {
          main: "#FF7900"
        },
        yellow: {
          main: "#FFE143"
        }
      }
    });

var $$location = window.location;

var tempMode = {
  contents: false
};

var initialStateSafeBase64 = new URLSearchParams($$location.search).get("editorState");

var editorInitialStateJsonStr = (initialStateSafeBase64 == null) ? Local_storage_utils.locStorReadString(MM_cmp_editor.editorStateLocStorKey) : (window.history.replaceState("removing editorState from the URL", "", $$location.origin + $$location.pathname), tempMode.contents = true, Common.safeBase64ToStr(initialStateSafeBase64));

if (tempMode.contents) {
  document.title = "TEMP " + document.title;
}

function MM_cmp_root(props) {
  var modalRef = Expln_React_Modal.useModalRef(undefined);
  var match = Expln_React_UseTabs.useTabs(undefined);
  var updateTabs = match.updateTabs;
  var activeTabId = match.activeTabId;
  var tabs = match.tabs;
  var removeTab = match.removeTab;
  var match$1 = React.useState(function () {
        var settings = MM_cmp_settings.settingsReadFromLocStor(undefined);
        return {
                preCtxData: MM_wrk_pre_ctx_data.preCtxDataMake(settings),
                ctxSelectorIsExpanded: true
              };
      });
  var setState = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        return true;
      });
  var setShowTabs = match$2[1];
  var showTabs = match$2[0];
  var reloadCtx = React.useRef(null);
  var toggleCtxSelector = React.useRef(null);
  var loadEditorState = React.useRef(null);
  var isFrameExplorerTab = function (tabData, label, param) {
    if (typeof tabData === "number") {
      return false;
    }
    if (tabData.TAG !== /* ExplorerFrame */1) {
      return false;
    }
    var lbl = tabData.label;
    return Belt_Option.mapWithDefault(label, true, (function (label) {
                  return lbl === label;
                }));
  };
  var actCloseFrmTabs = function (param) {
    tabs.forEach(function (tab) {
          if (isFrameExplorerTab(tab.data, undefined, undefined)) {
            return Curry._1(removeTab, tab.id);
          }
          
        });
  };
  var actSettingsUpdated = function (newSettings) {
    actCloseFrmTabs(undefined);
    MM_cmp_settings.settingsSaveToLocStor(newSettings);
    Curry._1(setState, (function (__x) {
            return updatePreCtxData(__x, newSettings, undefined, undefined);
          }));
    if (state.preCtxData.settingsV.val.descrRegexToDisc !== newSettings.descrRegexToDisc || state.preCtxData.settingsV.val.labelRegexToDisc !== newSettings.labelRegexToDisc || state.preCtxData.settingsV.val.descrRegexToDepr !== newSettings.descrRegexToDepr || state.preCtxData.settingsV.val.labelRegexToDepr !== newSettings.labelRegexToDepr) {
      return Belt_Option.forEach(Caml_option.nullable_to_opt(reloadCtx.current), (function (reloadCtx) {
                    Curry._5(reloadCtx, state.preCtxData.srcs, newSettings, true, true, undefined);
                  }));
    }
    
  };
  var actCtxSelectorExpandedChange = function (expanded) {
    Curry._1(setState, (function (__x) {
            return updateCtxSelectorIsExpanded(__x, expanded);
          }));
  };
  var openFrameExplorer = function (label) {
    Curry._1(setState, (function (st) {
            var match = MM_context.getFrame(st.preCtxData.ctxV.val, label);
            if (match !== undefined) {
              Curry._1(updateTabs, (function (tabsSt) {
                      var tab = Expln_React_UseTabs.getTabs(tabsSt).find(function (tab) {
                            return isFrameExplorerTab(tab.data, label, undefined);
                          });
                      if (tab !== undefined) {
                        return Expln_React_UseTabs.openTab(tabsSt, tab.id);
                      } else {
                        return Expln_React_UseTabs.addTab(tabsSt, label, true, undefined, {
                                      TAG: /* ExplorerFrame */1,
                                      label: label
                                    }, true, undefined)[0];
                      }
                    }));
            } else {
              MM_react_common.openInfoDialog(modalRef, "Cannot find an assertion by label '" + label + "'", undefined, undefined, undefined);
            }
            return st;
          }));
  };
  var openExplorer = function (initPatternFilterStr) {
    Curry._1(updateTabs, (function (tabsSt) {
            return Expln_React_UseTabs.addTab(tabsSt, "EXPLORER " + initPatternFilterStr.substring(0, 40) + "", true, undefined, {
                          TAG: /* ExplorerIndex */0,
                          initPatternFilterStr: initPatternFilterStr
                        }, true, undefined)[0];
          }));
  };
  var focusEditorTab = function (param) {
    Curry._1(updateTabs, (function (tabsSt) {
            var tab = Expln_React_UseTabs.getTabs(tabsSt).find(function (tab) {
                  var tabData = tab.data;
                  if (typeof tabData === "number") {
                    return tabData !== 0;
                  } else {
                    return false;
                  }
                });
            if (tab !== undefined) {
              return Expln_React_UseTabs.openTab(tabsSt, tab.id);
            } else {
              return tabsSt;
            }
          }));
  };
  React.useEffect((function () {
          Curry._1(updateTabs, (function (st) {
                  if (Expln_React_UseTabs.getTabs(st).length !== 0) {
                    return st;
                  }
                  var match = Expln_React_UseTabs.addTab(st, "Settings", false, undefined, /* Settings */0, undefined, undefined);
                  var match$1 = Expln_React_UseTabs.addTab(match[0], "Editor", false, tempMode.contents ? "orange" : undefined, /* Editor */1, true, undefined);
                  return Expln_React_UseTabs.addTab(match$1[0], "Explorer", false, undefined, {
                                TAG: /* ExplorerIndex */0,
                                initPatternFilterStr: ""
                              }, undefined, undefined)[0];
                }));
        }), []);
  var tmp = {};
  var tmp$1 = state.preCtxData.settingsV.val.hideContextSelector && !state.ctxSelectorIsExpanded ? "none" : undefined;
  if (tmp$1 !== undefined) {
    tmp.display = tmp$1;
  }
  return React.createElement(Styles.ThemeProvider, {
              theme: mainTheme,
              children: React.createElement(Expln_React_ContentWithStickyHeader.make, {
                    top: 0,
                    header: React.createElement(Expln_React_Column.make, {
                          children: Caml_option.some(null)
                        }, React.createElement(MM_cmp_context_selector.make, {
                              modalRef: modalRef,
                              settings: state.preCtxData.settingsV.val,
                              onUrlBecomesTrusted: (function (url) {
                                  actSettingsUpdated(MM_wrk_settings.markUrlAsTrusted(state.preCtxData.settingsV.val, url));
                                }),
                              onChange: (function (srcs, ctx) {
                                  actCloseFrmTabs(undefined);
                                  Curry._1(setState, (function (__x) {
                                          return updatePreCtxData(__x, undefined, [
                                                      srcs,
                                                      ctx
                                                    ], undefined);
                                        }));
                                }),
                              reloadCtx: reloadCtx,
                              style: tmp,
                              onExpandedChange: actCtxSelectorExpandedChange,
                              doToggle: toggleCtxSelector
                            }), showTabs ? Curry._1(match.renderTabs, undefined) : React.createElement("div", {
                                style: {
                                  display: "none"
                                }
                              })),
                    content: (function (contentTop) {
                        return React.createElement(Expln_React_Column.make, {
                                    children: Caml_option.some(null)
                                  }, tabs.map(function (__x) {
                                        var match = __x.data;
                                        var tmp;
                                        tmp = typeof match === "number" ? (
                                            match === /* Settings */0 ? React.createElement(MM_cmp_settings.make, {
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    onChange: actSettingsUpdated
                                                  }) : React.createElement(MM_cmp_editor.make, {
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    top: contentTop,
                                                    reloadCtx: reloadCtx,
                                                    loadEditorState: loadEditorState,
                                                    initialStateJsonStr: editorInitialStateJsonStr,
                                                    tempMode: tempMode.contents,
                                                    toggleCtxSelector: toggleCtxSelector,
                                                    ctxSelectorIsExpanded: state.ctxSelectorIsExpanded,
                                                    showTabs: showTabs,
                                                    setShowTabs: (function (b) {
                                                        Curry._1(setShowTabs, (function (param) {
                                                                return b;
                                                              }));
                                                      }),
                                                    openFrameExplorer: openFrameExplorer
                                                  })
                                          ) : (
                                            match.TAG === /* ExplorerIndex */0 ? React.createElement(MM_cmp_pe_index.make, {
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    openFrameExplorer: openFrameExplorer,
                                                    openExplorer: openExplorer,
                                                    toggleCtxSelector: toggleCtxSelector,
                                                    ctxSelectorIsExpanded: state.ctxSelectorIsExpanded,
                                                    initPatternFilterStr: match.initPatternFilterStr
                                                  }) : React.createElement(MM_cmp_pe_frame_full.make, {
                                                    top: contentTop,
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    label: match.label,
                                                    openFrameExplorer: openFrameExplorer,
                                                    openExplorer: openExplorer,
                                                    loadEditorState: loadEditorState,
                                                    focusEditorTab: focusEditorTab,
                                                    toggleCtxSelector: toggleCtxSelector,
                                                    ctxSelectorIsExpanded: state.ctxSelectorIsExpanded
                                                  })
                                          );
                                        return React.createElement("div", {
                                                    key: __x.id,
                                                    style: {
                                                      display: __x.id === activeTabId ? "block" : "none"
                                                    }
                                                  }, tmp);
                                      }), React.createElement(Expln_React_Modal.make, {
                                        modalRef: modalRef
                                      }));
                      })
                  })
            });
}

var make = MM_cmp_root;

exports.createInitialState = createInitialState;
exports.updatePreCtxData = updatePreCtxData;
exports.updateCtxSelectorIsExpanded = updateCtxSelectorIsExpanded;
exports.mainTheme = mainTheme;
exports.$$location = $$location;
exports.tempMode = tempMode;
exports.editorInitialStateJsonStr = editorInitialStateJsonStr;
exports.make = make;
/* mainTheme Not a pure module */
